<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.travel_ad')" :newButShow="true" @newBut="newBut('add')"></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ travel_name: true }" />
        <myTable ref="table" :columns="columns" requestUrl="ad-travel/list" :showPage="true">
          <template v-slot:action="{ data }">
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="newBut('edit',data.row)"
            />
            <Icon
              class="cursor_p mg-left15"
              @click="info(data.row)"
              type="ios-eye"
              size="26"
              color="#7D7C7F"
            />
            <Poptip
              placement="bottom"
              confirm
              :title="$t('confirm_delete')"
              @on-ok="handleDel(data.row)"
            >
              <Icon class="cursor_p mg-left15" type="md-trash" size="24" color="#7D7C7F" />
            </Poptip>
          </template>
          <template v-slot:ad_type="{ data }">
            <span v-if="data.row.ad_type == 1">{{$t('yes')}}</span>
            <span v-else>{{$t('no')}}</span>
          </template>
        </myTable>
      </div>
    </div>
    <edit v-if="modal" @onOk="onOk" :type="type" :modal="modal" :itemObj="itemObj" @cancel="cancel"></edit>
    <info v-if="modal2" :modal="modal2" :itemObj="itemObj" @cancel="cancel2"></info>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
import myTableFilter from "@/components/myTableFilter";
import edit from "./module/ad_edit";
import info from "./module/ad_info";
export default {
  name: "adInfo",
  components: {
    myTable,
    pageTitle,
    myTableFilter,
    edit,
    info
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          key: "ad_item_id",
          align: "center",
          width: 100,
        },
        {
          tooltip: true,
          minWidth: 200,
          title: this.$t("travel.name") + "(EN)",
          key: "en_cname",
          align: "center"
        },
        {
          tooltip: true,
          minWidth: 200,
          title: this.$t("travel.name") + "(繁体)",
          key: "zh-tw_cname",
          align: "center"
        },
        {
          tooltip: true,
          minWidth: 200,
          title: this.$t("travel.name") + "(简体)",
          key: "zh-cn_cname",
          align: "center"
        },
        {
          title: this.$t("Ad.beginDate"),
          width: 120,
          key: "begin_date",
          align: "center"
        },
        {
          title: this.$t("Ad.endDate"),
          width: 120,
          key: "end_date",
          align: "center"
        },
        {
          tooltip: true,
          width: 200,
          title: this.$t("Info.url"),
          key: "url_link",
          align: "center"
        },
        {
          title: this.$t("isJump"),
          width: 120,
          key: "tag_status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.link_status == 1
              },
              on: {
                'on-change': value => {
                  this.setLinkStatus(params.row.ad_item_id);
                }
              }
            });
          }
        },
        {
          title: this.$t("status"),
          width: 120,
          key: "tag_status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.status == 1
              },
              on: {
                'on-change': value => {
                  this.setStatus(params.row.ad_item_id);
                }
              }
            });
          }
        },
        {
          title: this.$t("Info.order"),
          width: 120,
          key: "sort_id",
          align: "center"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action",
          width: 160,
        },
      ],
      modal: false,
      modal2: false,
      itemObj: {},
      type: "add",
      id: this.$base.getRequest().id
    };
  },
  created () {
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    newBut (type, item) {
      this.type = type
      this.itemObj = item
      this.modal = true
    },
    cancel () {
      this.modal = false
    },
    info (item) {
      this.itemObj = item
      this.modal2 = true
    },
    cancel2 () {
      this.modal2 = false
    },
    onOk () {
      this.$base.msgSuccess(this.$t("op_ok"));
      this.$refs.table.getLoad();
    },
    setStatus (ad_item_id) {
      this.$base.showLoading();
      this.$request.sendPost(
        'ad-travel/upd-status',
        { ad_item_id: ad_item_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.onOk()
        }
      );
    },
    setLinkStatus (ad_item_id) {
      this.$base.showLoading();
      this.$request.sendPost(
        'ad-travel/upd-link-status',
        { ad_item_id: ad_item_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.onOk()
        }
      );
    },
    handleDel (item) {
      this.$base.showLoading();
      this.$request.sendPost(
        'ad-travel/del',
        { ad_item_id: item.ad_item_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.$refs.table.getLoad();
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/travelAd/travelAd.vue